<div class="container-fluid p-3">

  <div class="page-header mb-4">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h4 class="mb-1">Draft RFP & SoC</h4>
        <h5 class="text-primary">[{{ payload?.proposal_name }}]</h5>
        <div class="status-badge">
          <span class="badge" [ngClass]="{
              'bg-secondary': stepDetails?.step_status == 0,
              'bg-success': stepDetails?.step_status == 'approved',
              'bg-warning': stepDetails?.step_status == 'recommended',
              'bg-info': stepDetails?.step_status == 'initiated'
            }">
            {{
            stepDetails?.step_status == 0
            ? " PENDING"
            : (stepDetails?.step_status | uppercase)
            }}
          </span>
        </div>
      </div>

      <div class="action-buttons">
        <button class="btn btn-outline-secondary me-2" (click)="generatePDF()">
          <i class="pi pi-file-pdf me-1"></i> PDF
        </button>

        <ng-container *ngIf="PDSactiveIndex == 1 && stepDetails?.step_status == 'approved'">
          <button class="btn btn-outline-primary me-2" (click)="goToNextStep()">
            Next <i class="pi pi-angle-right ms-1"></i>
          </button>
        </ng-container>

        <ng-container *ngIf=" stepDetails.can_edit">
          <button *ngIf="PDSactiveIndex == 0" class="btn btn-primary me-2" (click)="onSubmit(0)"
            [disabled]="SOCForm.invalid">
            <i class="pi pi-save me-1"></i> Save
          </button>
          <button *ngIf="PDSactiveIndex == 1" class="btn btn-primary me-2"
            (click)="routeConfig.emit({isRouteConfig: true})" [disabled]="RFPForm.invalid">
            <i class="pi pi-save me-1"></i> Save/Forward/Route Config
          </button>
        </ng-container>


      </div>
    </div>
  </div>

  <!-- Vendor Management Section: hidden for Open Tender and Single Tender -->
  <app-vendor-management *ngIf="!hideVendorManagement" [stepDetails]="stepDetails"
    [schemeType]="schemeType || 'revenue'" [format]="'upload'" [url]="'/revenue/dms-file/vendor/'"
    [proposalStepId]="stepDetails?.id || step?.id" [proposalId]="stepDetails?.proposal || payload?.proposal_id"
    (vendorAdded)="onVendorAdded($event)" (vendorUpdated)="onVendorUpdated($event)"
    (vendorDeleted)="onVendorDeleted($event)" (filesSubmitted)="onFilesSubmitted($event)"></app-vendor-management>

  <!-- Fetch Data Button -->
  <div class="flex justify-end mb-3 mt-4 mx-3">

  </div>

  <!-- Tailwind tab two-section (with logic based on PDSactiveIndex) -->
  <!-- For schemeType = rev/revenue: SoC tab is hidden, only RFP tab is shown -->
  <div>
    <div class="flex justify-between gap-2 bg-slate-50 p-2 rounded">
      <div class="flex gap-2">
        <ng-container *ngFor="let t of items; let idx = index">
          <!-- *ngIf: hide SoC tab (idx === 0) when schemeType is rev or revenue -->
          <button *ngIf="!(schemeType === 'rev' || schemeType === 'revenue') || idx !== 0"
            class="relative px-4 py-2 rounded-full font-semibold text-sm transition-colors duration-200 focus:outline-none flex items-center gap-2"
            [ngClass]="
              PDSactiveIndex === idx
                ? 'bg-blue-950 text-white shadow-sm ring-2 ring-blue-100'
                : 'bg-gray-200 text-gray-700 hover:text-white hover:bg-blue-950'
            " (click)="setActiveStep(idx)" pTooltip="Switch to {{ t.label }} form" tooltipPosition="top"
            [attr.aria-selected]="PDSactiveIndex === idx" type="button">
            <i *ngIf="t.icon" class="pi" [ngClass]="t.icon"></i>
            <span>{{ t.label || (idx === 0 ? 'SoC' : 'RFP') }}</span>
          </button>
        </ng-container>

      </div>
      <div class="flex justify-end">
        <button type="button"
          class="inline-flex items-center gap-2 bg-blue-600 text-white font-semibold py-2 px-4 rounded shadow hover:bg-blue-700 transition focus:outline-none focus:ring-2 focus:ring-blue-400"
          (click)="fetchMasterData(PDSactiveIndex)" *ngIf="stepDetails.can_edit">
          <i class="pi pi-database"></i>
          Fetch Data from Masters
        </button>
      </div>
    </div>
    <div class="mt-2">
      <!-- SoC tab content: hidden when schemeType is rev/revenue -->
      <ng-container *ngIf="PDSactiveIndex === 0 && schemeType !== 'rev' && schemeType !== 'revenue'">
        <form [formGroup]="SOCForm" class="space-y-5">
          <div class="mb-4" *ngIf="init">
            <h2 for="comment" class="block mb-1 font-semibold text-white bg-blue-600 px-3 py-1">Comment <span
                class="text-yellow-400">*</span></h2>

            <editor *ngIf="showEditor" [init]="init" formControlName="comment" [disabled]="isEditorDisabled"></editor>

          </div>
        </form>
      </ng-container>
      <ng-container *ngIf="PDSactiveIndex === 1">
        <form [formGroup]="RFPForm" class="space-y-5">
          <!-- Noting Editor: visible only for revenue schemeType -->
          <div class="editor-field mb-4" *ngIf="(schemeType === 'rev' || schemeType === 'revenue') && init">
            <h2 class="block mb-1 font-semibold text-white bg-blue-600 px-3 py-1">Comment</h2>
            <editor [init]="init" *ngIf="showEditor" formControlName="noting" [disabled]="!stepDetails.can_edit"></editor>
          </div>

          <div class="mb-4" *ngIf="init">
            <h2 class="block mb-1 font-semibold text-white bg-blue-600 px-3 py-1">RFP Format <span
                class="text-yellow-400">*</span></h2>
            <editor [init]="init" *ngIf="showEditor" formControlName="comment" [disabled]="isEditorDisabled"></editor>
          </div>

          <!-- Document Upload: visible only for revenue schemeType -->
          <div *ngIf="schemeType === 'rev' || schemeType === 'revenue'">
            <app-upload-document [title]="'Document Upload'" [isEditable]="stepDetails?.can_edit">
            </app-upload-document>
          </div>
        </form>
      </ng-container>
    </div>
  </div>
  <div id="print-section" *ngIf="PDSactiveIndex === 1">
    <!-- Editor Content -->
    <div *ngIf="POCForm?.get('comment')?.value" [innerHTML]="POCForm?.get('comment')?.value" class="mb-4"></div>

    <!-- Table for Selected Stages -->
    <table class="table table-bordered dark-bordered-table">
      <thead>
        <tr>
          <th>Sr. No.</th>
          <th>Evaluation Element </th>
          <th>Deliverables for Evaluation</th>
          <th>Total Marks</th>
          <th>Minimum Qualifying Marks(Cut-off)</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let stage of selectedStages; let i = index">
          <td>{{ i + 1 }}</td>
          <td>{{ stage.name }}</td>
          <td>{{ stage.sub_name }}</td>
          <td>{{ stage.total_mark }}</td>
          <td>{{ stage.cut_off }}</td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <th colspan="3" class="text-end">Total</th>
          <th>{{ getTotalMarks() }}</th>
          <th>{{ getTotalCutoff() }}</th>
        </tr>
      </tfoot>
    </table>
  </div>